import React, { forwardRef } from 'react';
import BaseSelect from '../base-select';
import noop from '../../../utils/noop';
import { SIZES } from '../base-select/constants';

const defaultOptions = [];

const Autocomplete = forwardRef(
  (
    {
      clearable = true,
      defaultInputValue = '',
      inputValue = undefined,
      disabled = false,
      blurInputOnSelect = false,
      captureMenuScroll = false,
      id = undefined,
      invalid = false,
      asyncConfig = undefined,
      name = undefined,
      onBlur = noop,
      onCreateOption = undefined,
      filterOptionsFunction = undefined,
      onFocus = noop,
      onInputChange = noop,
      onKeyDown = noop,
      options = defaultOptions,
      placeholder = 'Select item',
      preventOverflow = false,
      size = SIZES.small,
      transparent = false,
      iconComponent = undefined,
      prefixTextComponent = undefined,
      defaultMenuIsOpen = false,
      autoFocus = false,
      openMenuOnFocus = false,
      menuIsOpen = undefined,
      noResultsText = undefined,
      maxMenuHeight = undefined,
      menuWidth = '',
      shouldMarkSelectedOption = false,
      withDropdownIndicator = false,
      menuPlacement = 'auto',
      onChange,
    },
    ref
  ) => (
    <BaseSelect
      appearance="autocomplete"
      clearable={clearable}
      disabled={disabled}
      menuPlacement={menuPlacement}
      id={id}
      invalid={invalid}
      name={name}
      defaultInputValue={defaultInputValue}
      inputValue={inputValue}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onChange={onChange}
      onCreateOption={onCreateOption}
      filterOptionsFunction={filterOptionsFunction}
      onFocus={onFocus}
      onInputChange={onInputChange}
      options={options}
      placeholder={placeholder}
      preventOverflow={preventOverflow}
      size={size}
      blurInputOnSelect={blurInputOnSelect}
      captureMenuScroll={captureMenuScroll}
      asyncConfig={asyncConfig}
      transparent={transparent}
      iconComponent={iconComponent}
      prefixTextComponent={prefixTextComponent}
      defaultMenuIsOpen={defaultMenuIsOpen}
      autoFocus={autoFocus}
      openMenuOnFocus={openMenuOnFocus}
      menuIsOpen={menuIsOpen}
      maxMenuHeight={maxMenuHeight}
      menuWidth={menuWidth}
      noResultsText={noResultsText}
      shouldMarkSelectedOption={shouldMarkSelectedOption}
      ref={ref}
      withDropdownIndicator={withDropdownIndicator}
    />
  )
);

Autocomplete.displayName = 'Autocomplete';

export default Autocomplete;
